// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.popup_dim .layer_close {z-index: 2998 !important}\n.popup_dim2 {z-index: 2999 !important}\n", ""]);
// Exports
module.exports = exports;
